import { render, staticRenderFns } from "./PublishTrademark.vue?vue&type=template&id=b4e45e54&scoped=true"
import script from "./PublishTrademark.vue?vue&type=script&lang=js"
export * from "./PublishTrademark.vue?vue&type=script&lang=js"
import style0 from "./PublishTrademark.vue?vue&type=style&index=0&id=b4e45e54&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e45e54",
  null
  
)

export default component.exports